import { Resourceful } from "../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../ResourceManager/ResourceManager";
import { LogGroup } from ".././MyHelpers";
import { IFeatureResult, SlotGameBet } from "../api";
import * as PIXI from "pixi.js";

export abstract class SlotFeature implements Resourceful
{
	protected gameName: string = "";
	protected featureName: string = "";
	protected resourcesBasePath: string = "";

	protected logGroup: LogGroup = null;
	//protected resid: string = "";

	protected parentresid: ResourceIdentifier = null;
	protected resid: ResourceIdentifier = null;



	public constructor(logGroup: LogGroup, resid: ResourceIdentifier, featureName: string, resourcesBasePath: string) {
		this.parentresid = resid;
		this.resid = resid.Add("Feature").Add(featureName);

		this.featureName = featureName;
		this.resourcesBasePath = resourcesBasePath;

		this.logGroup = logGroup.Add(featureName);
	}

	public abstract get IsRunning(): boolean;
	public abstract Prepare(params: IFeatureResult): void;
	public abstract Start(): void;
	public abstract RequestStop(): void;

	public UpdateBet(bet: SlotGameBet , bonusMultiplier : number): void {}

	public abstract Update(): void;
	public abstract PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void>;
	public abstract ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void>;
	public abstract View(): HTMLElement;	
}

export abstract class SlotFeaturePIXI extends SlotFeature{
	public abstract ViewPIXIAPP() : PIXI.Container;
	public abstract CreatePIXIAPP();
	public abstract Destroy();
}